import { Box, Stack, Grid, Typography } from "@mui/material";
import { Button, Input, Logo, Modal } from "../../components/Common";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { signUpInitialValues } from "../../helper/initialValues";
import Notification from "../../components/Common/Notification/Notification";
import { useEffect, useState } from "react";
import {getAffiliate, getPromoter, log, register, verifyEmail , checkIfAffiliateExists} from "../../Service/auth.service";
import { loginValidationSchema } from "../../helper/validation";
import { registerAffiliate } from "../../blockchain/contract";
import { useWeb3Modal } from "@web3modal/ethers/react";
import {
  useWeb3ModalProvider,
  useWeb3ModalAccount,
} from "@web3modal/ethers/react";
import { BrowserProvider, Contract } from "ethers";
import blockchaindata from "../../blockchain/Presale.json";
import { getCoupon,checkCoupon } from "../../Service/auth.service";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { LoadCanvasTemplateNoReload, loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';
import sendReferralMail, { getJsonCookies } from "../../helper/Helper";
import EmailVerificationModal from "../../components/EmailVerificationModal/EmailVerificationModal";
import { getIpAddress } from "../../helper/Helper";
import LogoSec from "../../components/Common/LogoSec";
import TermsAndCondition from "../../components/Common/Footer/TermsAndConditions";
import smallIcon from "../../assets/images/logogif.gif"

export default function Index() {
  const navigate = useNavigate();
  const [show, setShow] = useState({ show: false, type: "", message: "" });
  const { open } = useWeb3Modal();
  const { address, isConnected,chainId } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();
  const [contract, setcontract] = useState("");
  const [couponcheck, setcouponcheck] = useState(null)
  const [couponData, setCouponData] = useState([]);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [ triggerRegister , setTriggerRegister  ] = useState();
  const [isRefCouponParam,setIsRefCouponParam] = useState(false);
  const [walletAddress , setWalletAddress] = useState();
  const [isBNB , setIsBNB] = useState(false);
  const affiliateText1 = process.env.REACT_APP_PRESALE_AFFILIATE_TEXT_1;
  const affiliateText2 = process.env.REACT_APP_PRESALE_AFFILIATE_TEXT_2;
  const affiliateText3 = process.env.REACT_APP_PRESALE_AFFILIATE_TEXT_3;
  const affiliateText4 = process.env.REACT_APP_PRESALE_AFFILIATE_TEXT_4;
  const affiliateText5 = process.env.REACT_APP_PRESALE_AFFILIATE_TEXT_5;

  useEffect(() => {
    const initializePresale = async () => {
      try {
        await connectPresale();
      } catch (error) {
        console.log("Error initializing presale:", error);
      }
    };

    initializePresale().then(r => {}); // Call the async function
  }, []); // Dependency array remains empty to run only once on mount
  useEffect(() => {

    if (process.env.REACT_APP_ENVIRONMENT === "production") {
      if (chainId === 56) {
        setIsBNB(true);
      } else {
        setIsBNB(false);
      }
    } else if (process.env.REACT_APP_ENVIRONMENT === "development") {
      if (chainId === 31337) {
        setIsBNB(true);
      } else {
        setIsBNB(false);
      }
    }
  }, [chainId])

  useEffect( () => {
    async function callRegister(){
      const payload = {
        name: formik.values.name,
        email: formik.values.email,
        phoneNo: formik.values.phoneNumber,
        couponName: formik.values.couponName,
        webAddress: formik.values.web3,
        level: 'tier-1',
        token_name: process.env.REACT_APP_TOKEN_SYMBOL ?? null,
        refCouponName: formik.values.refCouponCode || null,
        discordAddress: formik.values.discord,
        telegramAddress: formik.values.telegram,
        twitterAddress: formik.values.twitter,
        youtubeAddress: formik.values.youtube,
      };
      const res = await checkIfAffiliateExists({wallet_address:address});
      if(res?.status){
        const result = await registerAffiliate(contract);
        if (result.status === 'success') {
          const registerAffiliatorResult = await register(payload);
          if (registerAffiliatorResult?.status){
            console.log("DATA SAVED")
          }else {
            setShow({
              show: true,
              type: 'error',
              message: registerAffiliatorResult.message || 'Something went wrong. Please try again later.',
            });
          }
          setShow({
            show: true,
            type: 'success',
            message: registerAffiliatorResult.message || 'Success',
          });
          formik.resetForm();
          formik.setFieldValue('web3', address);
          getCouponData(address);
          await sendReferralMail('pre-sale', formik.values.email,'5',formik.values.couponName);

          setTimeout(() => {
            navigate("/refer", {
              state: {
                url: formik.values.couponName,
              },
            });
          }, 2000);
        }
        else {
          setShow({
            show: true,
            type: 'error',
            message: result.message,
          });
        }
      }
      else {
        setShow({
          show: true,
          type: 'error',
          message: res.message || 'Something went wrong. Please try again later.',
        });
      }
      loadCaptchaEnginge(6); // Reload captcha after successful verification
    }
    if(triggerRegister === true){
      callRegister()
    }
  } , [triggerRegister])
  useEffect(() => {
    // Function to parse the query parameters from the URL
    const getQueryParams = (search) => {
      const queryParams = new URLSearchParams(search);
      return Object.fromEntries(queryParams.entries());
    };

    // Get the query parameters from the URL
    const queryParams = getQueryParams(window.location.search);
    // Access the 'ref' parameter value
    const ref = queryParams["ref"];

    // Set the 'refValue' state with the extracted value
    if (ref && ref !== undefined) {
      try {
        validateCoupon(ref);
      } catch (error) {

        // set ref coupon code hide
        setIsRefCouponParam(false);

        setShow({
          show: true,
          type: "error",
          message: "Invalid Coupon Code.",
        });
      }
    }
  }, []);

  async function validateCoupon(coupon) {
    const res = await getPromoter(coupon);
    if (res?.status) {

      // set ref coupon code show
      setIsRefCouponParam(true);

      formik.setFieldValue("refCouponCode", res.data.couponName)
    }
    else{
      // set ref coupon code hide
      setIsRefCouponParam(false);

      setShow({
        show: true,
        type: "error",
        message: "Invalid Coupon Code.",
      });
    }
  }

  useEffect(() => {
    const fetchIp = async () => {
      if (!isConnected) {
        const ip = await getIpAddress();  // Await the promise to get the IP address
        setWalletAddress(ip);  // Update the state with the IP address
      }
      else{
        setWalletAddress(address)
      }
    };

    fetchIp();  // Call the async function
  }, [isConnected , address]);  // Dependency array includes isConnected

  useEffect( () => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', async (accounts) => {
        // Optional: Re fetch details if the account changes (e.g., user switches accounts in MetaMask)
        if (accounts.length > 0) {
          await connectPresale();
        }
      })
    }
  } , [address])

  useEffect(() => {
    if (address) {
      formik.setFieldValue("web3", address);
      setWalletAddress(address)
      log({
        "webAddress": address,
        "message": "Wallet Address Changed"
      });
      getCouponData(address);
    }
  }, [address,chainId]);
  useEffect(() => {
    loadCaptchaEnginge(6); // Load captcha with 6 characters
  }, []);

  useEffect(() => {
    const savedAccountInfo = getJsonCookies('referaccount');
    if (savedAccountInfo){
      formik.setFieldValue("name" , savedAccountInfo.name);
      formik.setFieldValue("email" , savedAccountInfo.email);
      formik.setFieldValue("confirmMail" , savedAccountInfo.confirmMail);
      formik.setFieldValue("region" , savedAccountInfo.region);
    }
  } , [])
  //function to get the Affialiate information from coupon Code
  const getCouponData = async (add) => {
    if (address) {
      const res = await getCoupon(add);
      if (res?.status) {
        setCouponData(res.data);
      }
    }
  };

  // Connect wallet fn
  const connectWallet = async () => {
    if (!isConnected) {
      log({
        "webAddress": walletAddress,
        "message": "Click on Wallet Connect Button"
      });
      open();
    }
    else {
      if(!isBNB){
        setShow({
          show: true,
          type: 'error',
          message: "Please Switch on BINANCE SMART CHAIN NETWORK and try again.",
        });
      }
      else{
        console.log(formik.values);

        // Extracting the required fields from formik.values
        const { name, email, confirmMail, region } = formik.values;

        // Check if the 'referaccount' cookie exists
        const existingCookie = document.cookie
            .split("; ")
            .find((row) => row.startsWith("referaccount="));

        // Delete the existing cookie if it exists
        if (existingCookie) {
          document.cookie = "referaccount=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict;";
        }

        // Creating a 12-hour expiration date
        const expirationDate = new Date();
        expirationDate.setHours(expirationDate.getHours() + 12);

        // Creating the new cookie data
        const cookieData = {
          name: name || "",
          email: email || "",
          confirmMail: confirmMail || "",
          region: region || ""
        };

        // Setting the cookie with the new data
        document.cookie = `referaccount=${(JSON.stringify(cookieData))}; path=/; expires=${expirationDate.toUTCString()}; secure; samesite=strict;`;

        // Submitting the form
        formik.handleSubmit();

        log({
          "webAddress": walletAddress,
          "message": "Click on Submit Button"
        });
      }
    }
  };

  const connectPresale = async () => {

    if (!isConnected) {
      console.log("The wallet is not connected!");
      return;
    }

    const networkData = {
      56: blockchaindata.mainnet,
      31337: blockchaindata.hardhat
    };

    const network = networkData[chainId];
    if (!network) {
      setShow({
        show: true,
        type: "error",
        message: "You are not on BINANCE SMART CHAIN NETWORK.",
      });
      setIsBNB(false);
      return;
    }
    setIsBNB(true);
    const { contractAddress, abi } = network;
    const ethersProvider = new BrowserProvider(walletProvider);
    const signer = await ethersProvider.getSigner();

    try {
      const PresaleContract = new Contract(contractAddress, abi, signer);
      setcontract(PresaleContract);
    } catch (error) {
      setShow({
        show: true,
        type: "error",
        message: "Failed to connect",
      });
      console.log("Failed to connect to presale:", error);
    }
  };

  const handleCouponCode = async () => {
    try {
      log( {
        "webAddress": walletAddress,
        "message":  "Check Availibility button Clicked",
      })
      if(formik.values.couponName !== ""){
        const data = await checkCoupon(formik.values.couponName);
        if(data.status === true){
          console.log("Coupon Already available");
          log( {
            "webAddress": walletAddress,
            "message":  "Coupon Already available",
          })
          setcouponcheck(false);
        }
        else{
          setcouponcheck(true);
          log( {
            "webAddress": walletAddress,
            "message":  "Coupon not found",
          })
        }

      }else{
        console.log("Please enter coupon code!");
      }
    } catch (error) {
      console.log("Error fetching the coupon data: ",error);
    }
  }

  const formik = useFormik({

    initialValues: {...signUpInitialValues,   user_captcha_input: '' , region:'' , confirmMail: '' },
    validationSchema: loginValidationSchema,
    onSubmit: async (values , { resetForm , setFieldError}) => {
      const { user_captcha_input } = values;
      setTriggerRegister(false);
      if (!validateCaptcha(user_captcha_input)) {
        setFieldError("user_captcha_input", 'Captcha does not match'); // Set custom error if captcha is incorrect
        log({
          "webAddress": walletAddress,
          "message": "Captcha Failed"
        })
      } else {

        try {
          const verification = await verifyEmail({email: values.email});
          if(verification?.status === true){
            setIsEmailModalOpen(true)
          }
          else{
            setShow({
              show: true,
              type: "error",
              message: verification.message,
            });
            log( {
              "webAddress": walletAddress,
              "message":   verification.message,
            })
          }
        } catch (error) {
          console.log('Error in registerAffiliate', error);
        }
      }

    },

  });

  return (

      <>

        <Box
            sx={{
              px: 2,
              maxWidth: { xs: "800px", lg: "1100px" },
              height: "auto",
              width: "100%",
              margin: "auto",
            }}
        >
          <Stack
              flexDirection={{ xs: "column", lg: "row" }}
              gap={4}
              sx={{ height: "100%", width: "100%" }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} order={{ xs: 2, lg: 1 }} >
                <Stack sx={{ width: "100%" }} gap={{ xs: "10px", lg: 2 }}>
                  <Box sx={{ height: "100%", width: "100%", padding: { xs: 1 , sm: 1 } , }}>
                    <Stack sx={{ width: "100%" }} gap={{ xs: "10px", lg: 2 }}>
                      <Box className="card_container" sx={{
                        marginRight:{lg:"-15px"},
                        marginLeft:{lg:"19px"}
                      }}>
                        <Stack gap={{ xs: 2, lg: 3 }}>
                          {/* Fix this gap previous is 15 */}
                          <Stack gap={{ xs: 1, lg: "31px" }}>
                            <Typography
                                fontSize={{ xs: "10px", lg: "15px" }}
                                fontWeight={"600"}
                                // color={"#fff"}
                                className="text_typography_color">
                              With Crypto Launchpad ─ Early Access Network, you earn <u>over 20% + 10% = 30% commission on every sale</u> !
                            </Typography>
                            <Typography fontSize={{ xs: "10px", lg: "15px" }} fontWeight={"600"} className="text_typography_color" paddingTop={{lg: "20px"}}>
                              How The Two Steps Registration Works:
                            </Typography>
                            <Typography fontSize={{ xs: "10px", lg: "15px" }} className="text_typography_color" >
                              <strong>1) </strong>  10% // Via this Crypto Affiliate Page, you earn 10% in crypto presale tokens of this specific project.
                            </Typography>
                            <Typography fontSize={{ xs: "10px", lg: "15px" }} className="text_typography_color" >
                              We recommend using the same “Referral/Coupon ID” as on your Early Access Network affiliate page.
                            </Typography>
                            <Typography fontSize={{xs:"10px" , lg:"15px"}} className="text_typography_color">
                              Please note:   Earnings are tied to your Web3 wallet via smart contract. A small BNB gas fee is required to connect.
                            </Typography>
                            <Typography fontSize={{xs:"10px" , lg:"15px"}} className="text_typography_color">
                              <strong>2) </strong> + 20% // Join the Early Access Network as an affiliate and earn 20% commission on all launchpad presales. Payouts in ETH or BNB are sent quarterly to your Web3 wallet
                            </Typography>
                            <Typography fontWeight={"600"} fontSize={{xs:"10px" , lg:"15px"}} className="text_typography_color" paddingTop={{lg: "20px"}}>
                              Plus ─ Receive Extra Passive Earnings
                            </Typography>
                            <Typography fontSize={{xs:"10px" , lg:"15px"}} className="text_typography_color">
                              Passive Earnings ► 4.5% // Passive Income. Earn passive income — get 4.5% whenever your referrals use your ID-linked coupon to bring in new investors
                            </Typography>
                          </Stack>
                        </Stack>
                      </Box>
                    </Stack>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} lg={6} order={{ xs: 1, lg: 2 }} >
                <Stack sx={{ width: "100%" }} gap={{ xs: "10px", lg: 2 }}>
                  <Box sx={{ height: "100%", width: "100%", padding: { xs: 1, sm: 1 } }}>
                    <Stack
                        gap={5}
                        flexDirection={"row"}
                        justifyContent={"center"}
                        sx={{ height: "100%", width: "100%" }}
                        className=""
                    >
                      <Stack
                          sx={{
                            maxWidth: { xs: "100%", sm: "400px", lg: "500px" },
                            width: "100%",
                            justifyContent: "center",
                          }}
                          className=""
                      >
                        <Stack
                            sx={{
                              p: 3,
                              background: "#fff",
                              width:"500px"
                            }}
                            className="affialiteform rightTableBorder"
                        >

                          <Box
                              sx={{
                                display: {xs:"none" , lg:"flex"},
                                justifyContent: "center",
                                alignItems: "center",

                              }} mb={3}
                          >
                            <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
                              <LogoSec />
                              <img src ={smallIcon}  alt="Logo" style={{width: '23%', height: 'auto' , margin:'0 auto' ,paddingTop:"11px"}}/>

                            </Stack>
                          </Box>

                          <Grid container spacing={{ xs: "10px", lg: 2 }}>
                            <Grid item xs={12} md={6} lg={6}>
                              <Input
                                  required
                                  className="blue-box "
                                  textColor={"#3f127f"}
                                  labelinput="Your Name *"
                                  formik={formik}
                                  name="name"
                                  maxLength={50}
                                  //  color="#001c3c"
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Input

                                  labelinput="Country / Region *"
                                  formik={formik}
                                  textColor={"#3f127f"}
                                  name="region"
                                  maxLength={50}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Input
                                  required
                                  labelinput="Your E-Mail *"
                                  formik={formik}
                                  textColor={"#3f127f"}
                                  name="email"
                                  maxLength={50}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Input
                                  labelinput="Confirm E-Mail *"
                                  formik={formik}
                                  textColor={"#3f127f"}
                                  name="confirmMail"
                                  maxLength={50}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Input
                                  disabled={true}
                                  labelinput="Web-3 Address (Wallet Address) *"
                                  formik={formik}
                                  textColor={"#3f127f"}
                                  name="web3"
                                  maxLength={50}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Input
                                  labelinput="Create Referral / Coupon ID *"
                                  formik={formik}
                                  name="couponName"
                                  textColor={"#3f127f"}
                                  maxLength={50}
                              />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid style={{ marginTop: "19px" }}>
                                <button
                                    className="btn-blue connect_button"
                                    style={{padding:"18px"}}
                                    // buttonName={"Check Availability"}
                                    onClick={() => {
                                      if(!isConnected){
                                        setShow({
                                          show: true,
                                          type: 'error',
                                          message: "Please connect your wallet",
                                        });
                                      }
                                      else if(!isBNB){
                                        setShow({
                                          show: true,
                                          type: 'error',
                                          message: "Please Switch on BINANCE SMART CHAIN NETWORK and try again",
                                        });
                                      }
                                      else{
                                        handleCouponCode()
                                      }
                                    }}

                                >
                                  Check Availability
                                </button>
                              </Grid>
                              <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "17px",
                                    marginLeft: "10px",
                                  }}
                              >
                                {couponcheck == null ? <></>: couponcheck ? <span style={{ color: "#06cbdb", fontSize: "30px" }}>V</span>
                                    : <span style={{ color: "red", fontSize: "30px" }}>X</span>}
                              </div>
                            </Grid>
                            {isRefCouponParam && (
                                <Grid item xs={12}>
                                  <Grid  xs={6}>
                                    <Input
                                        disabled={true}
                                        labelinput="Promoter Coupon Code"
                                        formik={formik}
                                        textColor={"#3f127f"}
                                        name="refCouponCode"
                                        maxLength={5}
                                    />
                                  </Grid>
                                </Grid>
                            )}
                             <Grid item xs={12}>
                               <Typography fontSize={10}>
                                 After registering, please check your inbox or spam folder for the verification email
                               </Typography>
                            <Typography fontSize={10} display="inline">
                              By registering, you agree to Our
                            </Typography>
                            <Typography fontSize={10} marginLeft="2px"display="inline" component="span" sx={{ textDecoration: 'underline' }}>
                              <Link to="/terms-and-condition" className="text_typography_color" style={{ textDecoration: 'none' }}>
                                 Terms and Conditions
                              </Link>
                            </Typography>
                          </Grid>
                            <Grid  xs={12} md={6} lg={6}   sx={{marginTop:"35px"}}>
                              <LoadCanvasTemplateNoReload  />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Input
                                  fullWidth
                                  formik={formik}
                                  id="user_captcha_input"
                                  name="user_captcha_input"
                                  textColor={"#3f127f"}
                                  labelinput="Enter Captcha"
                                  value={formik.values.user_captcha_input}
                                  error={formik.touched.user_captcha_input && Boolean(formik.errors.user_captcha_input)}
                              />

                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
                              <button
                                  className="btn-register connect_button"
                                  type="submit"
                                  onClick={() => {
                                    connectWallet()
                                  }}
                                  // buttonName="Register"
                                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                              >
                                {isConnected ? "Continue" : "Connect Wallet"}
                                <KeyboardDoubleArrowRightIcon color="#f5deb37d" />
                              </button>
                            </Grid>
                          </Grid>
                        </Stack>
                        <Stack mt={2}>
                          <Typography
                              color="white.main"
                              fontSize={"20px"}
                              mb={1}
                              fontWeight={"600"}
                          >
                            Connected web3 URL
                          </Typography>
                          {couponData &&
                              couponData.length > 0 &&
                              couponData.map((item, index) => (
                                  <Typography color="white.main">
                                    <Link to={item} target="_blank">
                                      {item}
                                    </Link>
                                  </Typography>
                              ))}
                        </Stack>
                      </Stack>
                    </Stack>
                    <EmailVerificationModal
                        size={"lg"}
                        modalOpen={isEmailModalOpen}
                        handleClose={() =>
                            setIsEmailModalOpen(false)
                        }
                        formik={formik}
                        show={show}
                        setShow={setShow}
                        triggerRegister={setTriggerRegister}
                    />
                    <Notification show={show} setShow={setShow} />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </Box>

      </>



  );
}
